import { Flex, FlexProps } from '@chakra-ui/react'
import React from 'react'

import { Pill } from '../Pill/Pill'

interface Props extends FlexProps {
  label?: string
}
export const SidebarFilterCounter = ({ label, ...props }: Props) => {
  return (
    <Flex direction="row" justifyContent="flex-end" width="100%" {...props}>
      {label && (
        <Pill size="md" variant="chip-solid">
          {label}
        </Pill>
      )}
    </Flex>
  )
}
